<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     用户列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="up-list" :class="{ 'is-collapse': collapse, 'fold': tagManagerFold }">
    <div class="tag-area" :class="!collapse && 'no-collapse'">
      <tag-manager ref="tagManager" v-model="query.tagid" type="member" @toggle="handleTagManagerToggle"
        @change="fetchData(1, 1)" @update="fetchData(1, 1)" @delete="fetchData(1, 1)">
        <div slot="tag-name">用户管理</div>
      </tag-manager>
    </div>
    <div class="table-area">
      <div class="filter-container">
        <div class="filter-box">
          <div class="filter-item sm">
            <f-search-input v-model="query.keyword" width="160" placeholder="名称" prefix-icon="el-icon-search" clearable
              @change="fetchData(1, 1)" />
          </div>
        </div>
        <div class="toolbox">
          <f-sort-selector v-model="query.sort" :options="sortOptions" width="80" @change="fetchData(1, 1)" />
        </div>
      </div>
      <el-card v-loading="loading" shadow="never" class="card">
        <el-table ref="listTable" :data="list" tooltip-effect="dark">
          <el-table-column width="60" type="index" label="#" />
          <el-table-column width="60">
            <template slot-scope="scope">
              <f-user-avatar :src="scope.row.avatar" shape="rounded" />
            </template>
          </el-table-column>

          <el-table-column label="名称" min-width="180" show-overflow-tooltip>
            <div slot-scope="scope">
              <div class="flex align-items-center">
                <span class="font-md member-datil" @click="toDetail(scope.row.memberid)">{{ scope.row.nickname }}</span>
                <span v-if="scope.row.is_relater" class="text-primary ml-xs">@成员</span>
                <div v-if="scope.row.expire_day" class="pro-member ml-xs flex-center"
                  :class="[now < scope.row.expire_day ? 'orange' : 'grey']">
                  <span class="pro">PRO</span>
                  <span class="pro-time" v-if="now < scope.row.expire_day">{{ scope.row.expire_day |
                    parseTime('{y}/{m}/{d}') }}到期</span>
                  <span class="pro-time" v-else>{{ scope.row.expire_day | parseTime('{y}/{m}/{d}') }}已过期</span>
                </div>
                <tag-panel :ref="'tagPanel' + scope.row.memberid" class="ml-sm" type="member"
                  :unique-key="scope.row.memberid" :title="scope.row.nickname" :tags="scope.row.tags"
                  @update="handleTagPanelUpdate" />
              </div>
              <div v-if="scope.row.remark" class="text-muted font-sm" style="line-height: 17px;">{{ scope.row.remark }}
              </div>
            </div>
          </el-table-column>
          <el-table-column label="最近活跃" min-width="200">
            <template slot-scope="scope">
              <RmsMemberActiveCurve :ref="'activeCurve' + scope.row.memberid" :memberid="scope.row.memberid"
                style="height: 40px;width: 75%;" />
            </template>
          </el-table-column>

          <el-table-column label="设备数量" width="160" align="center">
            <template slot-scope="scope">
              <span class="font-lg">{{ scope.row.total_bind_sum }}</span>
            </template>
          </el-table-column>

          <el-table-column label="注册时间" width="160" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d}') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="viewMemberDetail(scope.row.memberid)">查看</el-button>
              <el-button type="text" @click="editRemark(scope.row)">备注</el-button>
            </template>
          </el-table-column>

          <template slot="append">
            <div class="foot-menu" :class="[!collapse && 'active', !tagManagerFold && 'fold']">
              <f-table-footer>
                <template slot="right">
                  <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize"
                    @change="fetchData(1)" />
                </template>
              </f-table-footer>
            </div>
          </template>
          <template slot="empty">
            <div class="flex-center mt-hg">
              <img src="../../assets/no-data.png" alt="" class="no-data">
            </div>
          </template>

        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getMemberListApi } from "@/api/up/upMemberApi";
import { postMemberProfileApi } from "@/api/up/upMemberApi";

export default {
  name: "UpList",

  components: {
    TagManager: () => import("@/views/fam/components/TagManager"),
    TagPanel: () => import("@/views/fam/components/TagPanel"),
    MemberActiveHeatmap: () => import("./components/MemberActiveHeatmap.vue"),
    MemberActiveCurve: () => import("./components/MemberActiveCurve.vue"),
  },
  data() {
    return {
      loading: false,
      memberid: 0,
      query: {
        tagid: 0,
        keyword: "",
        pindex: 1,
        sort: undefined,
        psize: this.$store.state.commonStore.psize,
      },
      list: [],
      total: 0,
      sortOptions: [
        { value: 0, title: "最近注册" },
        { value: 1, title: "最早注册" },
        { value: 2, title: "最多设备" },
      ],

      tagManagerFold: Number(
        localStorage.getItem(`__TAG_MANAGER_FOLD_MEMBER__`)
      ),
      now: parseInt(new Date().getTime() / 1000),
    };
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
    authArr() {
      return this.$store.state.rmsStore.authArr;
    },
    authObj() {
      return this.$store.getters.authObj;
    },
    remarkModify() {
      return this.$store.state.memberStore.remarkModify;
    },
  },

  watch: {
    remarkModify(nval) {
      if (nval) this.fetchData();
    },
  },
  created() {
    this.fetchData(1);
  },

  methods: {
    toRmsDetail(id) {
      this.$detail({type:'equip',id:id});
    },
    fetchData(loading = false, page) {
      if (loading) this.loading = true;
      if (page) this.query.pindex = page;
      getMemberListApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.query.sort = res.data.sort;
        }
      });
    },

    editRemark(row) {
      this.$prompt(`请输入备注信息`, row.nickname || "未授权用户", {
        inputValue: row.remark,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          postMemberProfileApi({ memberid: row.memberid, remark: value }).then(
            (res) => {
              if (!res.errno) {
                this.fetchData(1);
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch(() => {
          // 取消
        });
    },

    handleTagManagerToggle(val) {
      this.tagManagerFold = val;
    },
    handleTagPanelUpdate() {
      this.fetchData(1);
      this.$refs["tagManager"].fetchData();
    },

    viewMemberDetail(memberid) {
      this.memberid = memberid;
      this.$memberdetail({ memberid });
    },

    toDetail(memberid) {
      const _this = this;
      this.$memberdetail({ memberid });
    },
  },
};
</script>

<style lang="scss" scoped>
.up-list {
  .tag-area {
    position: fixed;
    top: 60px;
    left: 160px;
    width: 240px;
    height: calc(100% - 60px);
    background-color: #fff;

    &.no-collapse {
      border-bottom-left-radius: 20px;
    }
  }

  .table-area {
    padding-left: 240px;
    padding-bottom: 60px;

    /deep/ .card {
      margin-bottom: 20px;
      border: none;
    }
  }

  &.fold {
    .tag-area {
      width: 60px;
    }

    .table-area {
      padding-left: 60px;
    }
  }

  &.is-collapse {
    .tag-area {
      left: 60px;
    }
  }
}

/deep/ .sort {
  width: 80px;
}

.no-data {
  width: 200px;
  height: 200px;
}

.member-datil {
  cursor: pointer;

  &:hover {
    color: #07c160;
  }
}

.foot-menu {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 120px;
  width: calc(100% - 120px);
  z-index: 3;
  padding-left: 20px;
  padding: 4px 30px 5px 20px;

  &.active {
    left: 220px;
    width: calc(100% - 220px);
  }

  &.fold {
    left: 300px;
    width: calc(100% - 300px);
  }

  &.active.fold {
    left: 400px;
    width: calc(100% - 400px);
  }

  .f-table-footer {
    margin: 0;
    height: 50px;
  }
}

.pro-member {
  height: 18px;
  width: 40px;
  line-height: 1;
  border-radius: 30px 30px 30px 10px;
  text-align: center;
  font-size: 12px;
  padding: 0px 5px;
  color: white;

  .pro {
    padding: 0 5px;
  }

  .pro-time {
    display: none;
    padding: 0 5px;
  }

  &:hover {
    width: 150px;

    .pro-time {
      display: block;
      border-left: 1px solid white;
    }
  }

  &.orange {
    background-color: rgba(242, 150, 25, 1);
  }

  &.grey {
    background-color: rgba(144, 147, 153, 1);
  }
}
</style>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 0;
  border: 1px solid rgba(220, 223, 230, 1);

  .el-drawer__close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

.header {
  width: 100%;
  padding-bottom: 15px;

  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 5px;
  }

  .nickname {
    margin-left: 15px;
    height: 30px;
    line-height: 30px;
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
  }

  .createtime {
    height: 30px;
    line-height: 30px;
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    margin-left: 15px;
  }

  .remark {
    margin-left: 15px;
    margin-top: 5px;

    .edit {
      display: inline-block;

      &:hover {
        cursor: pointer;
      }
    }
  }
}

.active-level {
  padding: 20px 20px 0 20px;
  font-size: 16px;
}

.equip-list {
  padding: 0 20px;
  font-size: 16px;

  .bindList {
    height: 40px;
    line-height: 40px;
  }
}
</style>

<style lang="scss">
.el-dialog.detail-dialog {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .close {
    position: absolute;
    top: -5px;
    right: -30px;

    i {
      color: #fff;
      font-size: 28px;
      cursor: pointer;
      transition: transform 0.18s;
      transition: transform 0.18s, -webkit-transform 0.18s;

      &:hover {
        -webkit-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        transform: rotate(90deg);
      }
    }
  }
}
</style>
